import React from 'react';
import clsx from 'clsx';
import Heading from '../../../Typography/Heading';
import TextButton from '../../TextButton';
import Button from '../../Button';
import * as styles from './style.module.css';
const FilterBubbleMenuContent = ({ menuHeading, menuSelectButtonLabel, menuClearButtonLabel, menuDoneButtonLabel, clearable = false, onMenuSelectButtonClick, onDone, onClear, children, }) => {
    const headingClasses = clsx(styles.heading, styles.leftColumnItem);
    const contentClasses = clsx(styles.content);
    const clearButtonClasses = clsx(styles.footer, styles.leftColumnItem);
    const doneButtonClasses = clsx(styles.footer, styles.rightColumnItem);
    return (React.createElement("div", { className: styles.root },
        React.createElement(Heading, { typeStyle: "title3", color: "base", className: headingClasses }, menuHeading),
        menuSelectButtonLabel && (React.createElement(TextButton, { buttonType: "inline", text: menuSelectButtonLabel, onClick: onMenuSelectButtonClick, sidePadding: false, className: styles.rightColumnItem })),
        React.createElement("div", { className: contentClasses }, children),
        menuClearButtonLabel && (React.createElement(TextButton, { buttonType: "inline", text: menuClearButtonLabel, onClick: onClear, disabled: !clearable, sidePadding: false, className: clearButtonClasses })),
        React.createElement(Button, { buttonType: "secondary1", text: menuDoneButtonLabel || '', onClick: onDone, fullWidth: false, size: "medium", className: doneButtonClasses })));
};
export default FilterBubbleMenuContent;
//# sourceMappingURL=index.js.map